const { CountUp } = require('countup.js');

function initialize() {
    const options = {
        useEasing: true,
        useGrouping: true,
        separator: ',',
        decimal: '.',
        enableScrollSpy: false,
        scrollSpyOnce: false, //Bug, utilizado IntersectionObserver p/ resolver
        prefix: '+',
    };

    const counters = [...document.querySelectorAll('.animate-counter')].map((item) => {
        options.decimalPlaces = Number(item.dataset.value) % 1 ? 1 : 0;    
        options.suffix = item.dataset.suffix ? "<span class='text-3xl font-light'>" + item.dataset.suffix + "</span>" : "";

        return new CountUp(item, item.dataset.value, options);
    });

    const observer = new IntersectionObserver(function (entries, observer) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                counters.forEach((v) => {
                    setTimeout(function () {
                        v.start();
                    }, 700);
                });
            }
        });
    });

    observer.observe(document.querySelector('.animate-counter'));
}

window.onload = function () {
    initialize();
};
